import React from 'react'
import Headers from '../headers/Headers'
import Footers from '../footers/Footers'
import FooterCall from '../footers/FooterCall'

const ProjectMC = () => {
  return (
    <>
      <Headers/>
      <div>
        <h1>Project Management Conultant</h1>
      </div>
      <Footers/>
            <FooterCall/>
    </>
  )
}

export default ProjectMC
